/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    export class MeevoMonthYearSelector implements angular.IDirective {
        restrict = "E";
        scope = {
            startDate: "=",
            endDate: "="
        };

        


        templateUrl = "app/components/controls/monthYearSelectorTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var months = _.range(1, 13);
            scope.yearList = _.range(1900, parseInt(moment().format("YYYY")) + 1);
            scope.monthList = _.map(months, (month: any) => {
                return {
                    index: month,
                    label: moment(month, "M").format("MMMM")
                }
            });

            scope.change = () => {
                //scope.monthmodel -1 is due to moment using a 0 based month for input
                scope.startDate = moment(scope.startDate).set("month", scope.monthModel - 1).set("year", scope.yearModel).startOf('month').format();
                scope.endDate = moment(scope.endDate).set("month", scope.monthModel - 1).set("year", scope.yearModel).endOf('month').format();
            }


            if (scope.startDate) {
                scope.monthModel = moment(scope.startDate).format("M");
                scope.yearModel = moment(scope.startDate).format("YYYY");
            } else {
                scope.monthModel = moment().format("M");
                scope.yearModel = moment().format("YYYY");
            }
            scope.change();
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoMonthYearSelector();
            };

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoMonthYearSelector", MeevoMonthYearSelector.factory());
}
